import { atom, selector } from 'recoil'
import searchParamsState from './searchParamsState'

const searchResultsState = atom({
  default: null,
  key: 'searchResults',
})

export const filteredSearchResultsState = selector({
  get: ({ get }) => {
    const unfilteredResults = get(searchResultsState)
    const searchParams = get(searchParamsState)

    if (unfilteredResults && !searchParams.showAccountsWithoutApplications) {
      return unfilteredResults.filter(item => item.applications.length > 0)
    } else {
      return unfilteredResults
    }
  },
  key: 'filteredSearchResultsState',
})

export default searchResultsState
